import { useQuery } from '@tanstack/react-query';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { VersionComparisonV3 } from '@/types/automations.ts';
import { get_automation_version_comparison_v3_url } from '@/utils/urls.ts';

export default function useRetrieveVersionComparisonV3(baseVersionId?: string, targetVersionId?: string, enabled = true, reviewSession?: number) {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  return useQuery<VersionComparisonV3, Error>({
    queryKey: ['automation-version-comparison-v3', automationId, baseVersionId, targetVersionId, reviewSession],
    staleTime: 0,
    queryFn: async () => (await apiClient.get(get_automation_version_comparison_v3_url(targetVersionId), { params: { base_version_id: baseVersionId } })).data,
    enabled: enabled && !!automationId && !!baseVersionId && !!targetVersionId && baseVersionId !== targetVersionId,
  });
}
